import { render, staticRenderFns } from "./DMRPage.vue?vue&type=template&id=7e65afb4&scoped=true&"
import script from "./DMRPage.vue?vue&type=script&lang=js&"
export * from "./DMRPage.vue?vue&type=script&lang=js&"
import style0 from "./DMRPage.vue?vue&type=style&index=0&id=7e65afb4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e65afb4",
  null
  
)

export default component.exports